import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import {
  addNotificationFailure,
  addNotificationSuccess,
  fetchNotificationFailure,
  fetchNotificationSuccess,
} from "./actions";
import { FETCH_NOTIFICATION, ADD_NOTIFICATION } from "./constants";

export function* fetchNotificationSaga({ payload, onFetch }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload?.data ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/notification_setting?${query}`,
      payload
    );
    yield put(fetchNotificationSuccess(data));
    typeof onFetch === "function" && onFetch(data);
  } catch (e) {
    yield put(fetchNotificationFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching notifications!"));
  }
}

export function* addNotificationSaga({ payload, onAdd }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/notification_setting/add`,
      payload
    );
    if (data) {
      yield put(addNotificationSuccess());
      typeof onAdd === "function" && onAdd(true);
    }
  } catch (e) {
    yield put(addNotificationFailure());
    typeof onAdd === "function" && onAdd(false);
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchNotificationFlow() {
  yield takeEvery(FETCH_NOTIFICATION, fetchNotificationSaga);
}
export function* addNotificationFlow() {
  yield takeEvery(ADD_NOTIFICATION, addNotificationSaga);
}

export default function* NotificationSaga() {
  yield all([fetchNotificationFlow(), addNotificationFlow()]);
}
